import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { PieChart, Pie, Cell, BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import './Home.css';

const COLORS = ['#810055', '#A4A5AA', '#9d1068', '#b32080', '#6d0047', '#33C037'];

const dummyPieData = [
  { name: 'A', value: 40 },
  { name: 'B', value: 30 },
  { name: 'C', value: 20 },
  { name: 'D', value: 10 }
];

const dummyBarData = [
  { name: 'Jan', value: 30 },
  { name: 'Feb', value: 45 },
  { name: 'Mar', value: 28 },
  { name: 'Apr', value: 55 },
  { name: 'May', value: 40 },
  { name: 'Jun', value: 35 }
];

const Home = () => {
  return (
    <div className="dashboard-container">
      <Row className="g-3" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                  <Pie data={dummyPieData} cx="50%" cy="50%" innerRadius={40} outerRadius={70} dataKey="value">
                    {dummyPieData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <BarChart data={dummyBarData}>
                  <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="value" fill="#810055" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                  <Pie data={dummyPieData} cx="50%" cy="50%" outerRadius={70} dataKey="value">
                    {dummyPieData.map((_, i) => <Cell key={i} fill={COLORS[(i + 2) % COLORS.length]} />)}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <BarChart data={dummyBarData}>
                  <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="value" fill="#9d1068" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                  <Pie data={dummyPieData} cx="50%" cy="50%" innerRadius={30} outerRadius={60} paddingAngle={5} dataKey="value">
                    {dummyPieData.map((_, i) => <Cell key={i} fill={COLORS[(i + 1) % COLORS.length]} />)}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} xl={4} style={{ display: 'flex' }}>
          <Card className="dashboard-card">
            <Card.Body>
              <ResponsiveContainer width="100%" height={180}>
                <LineChart data={dummyBarData}>
                  <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Line type="monotone" dataKey="value" stroke="#810055" strokeWidth={2} dot={{ fill: '#810055' }} />
                </LineChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
